// extracted by mini-css-extract-plugin
export default {"optionContainer":"styles__optionContainer___qyR1y","processingIcon":"styles__processingIcon___Z40EZ","spin":"styles__spin___OOXEM"};